import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { JsonLdBuilder } from '../../structured-data.model';
import { BoelsPointOfService } from '@boels/models';

@Injectable()
export class JsonldLocalBusinessAddressBuilder
  implements JsonLdBuilder<BoelsPointOfService>
{
  build(pointOfService: BoelsPointOfService): Observable<any> {
    const schema: {
      '@type': string;
      streetAddress?: string;
      addressLocality?: string;
      postalCode?: string;
      addressRegion?: string;
      addressCountry?: string;
    } = { '@type': 'PostalAddress' };
    const address = pointOfService.address;
    if (address) {
      if (address.line1 && address.line2) {
        schema.streetAddress = `${address.line1} ${address.line2}`;
      }
      if (address.town) {
        schema.addressLocality = address.town;
      }
      if (address.postalCode) {
        schema.postalCode = address.postalCode;
      }
      if (address.region?.isocode) {
        schema.addressRegion = address.region.isocode;
      }
      if (address.country?.isocode) {
        schema.addressCountry = address.country.isocode;
      }
    }

    return of({ address: schema });
  }
}
